/**
 * Product Gallery Navigation Dots
 * Handles vertical navigation dots for product image gallery with Slick slider
 */

class ProductGalleryNavigation {
  constructor() {
    this.galleryContainer = null;
    this.navigationDots = null;
    this.slickSlider = null;
    this.dots = [];
    this.currentIndex = 0;
    this.isInitialized = false;
    
    this.init();
  }
  
  init() {
    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setupGallery());
    } else {
      this.setupGallery();
    }
  }
  
  setupGallery() {
    // Find gallery container and navigation dots
    this.galleryContainer = document.querySelector('.productView-nav[data-image-gallery-main]');
    this.navigationDots = document.querySelector('[data-navigation-dots]');
    
    if (!this.galleryContainer || !this.navigationDots) {
      // Retry after a short delay if elements not found
      setTimeout(() => this.setupGallery(), 500);
      return;
    }
    
    this.dots = Array.from(this.navigationDots.querySelectorAll('.navigation-dot'));
    
    if (this.dots.length === 0) {
      return;
    }
    
    // Check if slick is already initialized
    if ($(this.galleryContainer).hasClass('slick-initialized')) {
      this.bindSlickEvents();
    } else {
      // Wait for slick to initialize
      this.waitForSlickInit();
    }
    
    this.bindDotEvents();
    this.isInitialized = true;
  }
  
  waitForSlickInit() {
    const checkSlick = () => {
      if ($(this.galleryContainer).hasClass('slick-initialized')) {
        this.bindSlickEvents();
      } else {
        setTimeout(checkSlick, 100);
      }
    };
    checkSlick();
  }
  
  bindSlickEvents() {
    const $slider = $(this.galleryContainer);
    this.slickSlider = $slider;
    
    // Listen for slide changes
    $slider.on('afterChange', (event, slick, currentSlide) => {
      this.updateActiveStates(currentSlide);
    });
    
    // Set initial active state
    this.updateActiveStates(0);
  }
  
  bindDotEvents() {
    this.dots.forEach((dot, index) => {
      // Click event
      dot.addEventListener('click', (e) => {
        e.preventDefault();
        this.goToSlide(index);
      });
      
      // Keyboard navigation
      dot.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.goToSlide(index);
        } else if (e.key === 'ArrowUp' && index > 0) {
          e.preventDefault();
          this.dots[index - 1].focus();
        } else if (e.key === 'ArrowDown' && index < this.dots.length - 1) {
          e.preventDefault();
          this.dots[index + 1].focus();
        }
      });
    });
  }
  
  goToSlide(index) {
    if (!this.slickSlider || index < 0 || index >= this.dots.length) {
      return;
    }
    
    // Use slick's slickGoTo method
    this.slickSlider.slick('slickGoTo', index);
  }
  
  updateActiveStates(newIndex) {
    if (newIndex === this.currentIndex) {
      return;
    }
    
    // Remove active class and accessibility attributes from current dot
    if (this.dots[this.currentIndex]) {
      this.dots[this.currentIndex].classList.remove('active');
      this.dots[this.currentIndex].setAttribute('aria-current', 'false');
      this.dots[this.currentIndex].setAttribute('tabindex', '-1');
    }
    
    // Add active class and accessibility attributes to new dot
    if (this.dots[newIndex]) {
      this.dots[newIndex].classList.add('active');
      this.dots[newIndex].setAttribute('aria-current', 'true');
      this.dots[newIndex].setAttribute('tabindex', '0');
    }
    
    this.currentIndex = newIndex;
  }
  
  // Public methods for external use
  next() {
    if (this.slickSlider) {
      this.slickSlider.slick('slickNext');
    }
  }
  
  prev() {
    if (this.slickSlider) {
      this.slickSlider.slick('slickPrev');
    }
  }
  
  getCurrentIndex() {
    return this.currentIndex;
  }
  
  getTotalSlides() {
    return this.dots.length;
  }
}

// Initialize when jQuery and document are ready
$(document).ready(() => {
  // Add a delay to ensure slick slider is initialized
  setTimeout(() => {
    window.productGalleryNavigation = new ProductGalleryNavigation();
  }, 1000);
});

// Also initialize on theme section loads (for theme editor)
if (typeof theme !== 'undefined' && theme.ProductGallery) {
  const originalInit = theme.ProductGallery.init;
  theme.ProductGallery.init = function() {
    originalInit.apply(this, arguments);
    setTimeout(() => {
      if (window.productGalleryNavigation) {
        window.productGalleryNavigation.init();
      } else {
        window.productGalleryNavigation = new ProductGalleryNavigation();
      }
    }, 500);
  };
}

// Reinitialize on variant change
$(document).on('variantChange', () => {
  setTimeout(() => {
    if (window.productGalleryNavigation) {
      window.productGalleryNavigation.init();
    }
  }, 300);
});